import React from 'react';

// Animazione "indagine": lente d'ingrandimento con scansione interna + onde sonar.
// SVG autonomo (SMIL), colori dal tema (--accent). Usato durante l'agente Indaga.
export default function IndagaAnim() {
  const ACC = 'var(--accent, #e8600a)';
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, padding: '18px 0 8px' }}>
      <svg viewBox="0 0 130 130" width="118" height="118" style={{ overflow: 'visible' }}>
        {/* onde sonar che si espandono dal centro della lente */}
        {[0, 0.6, 1.2].map((b, i) => (
          <circle key={i} cx="54" cy="54" r="16" fill="none" stroke={ACC} strokeWidth="2">
            <animate attributeName="r" values="16;48" dur="1.8s" begin={`${b}s`} repeatCount="indefinite" />
            <animate attributeName="opacity" values="0.5;0" dur="1.8s" begin={`${b}s`} repeatCount="indefinite" />
          </circle>
        ))}

        {/* lente */}
        <circle cx="54" cy="54" r="22" fill="rgba(0,0,0,0.03)" stroke="currentColor" strokeWidth="4" style={{ color: '#0f172a' }} />

        {/* linea di scansione che ruota dentro la lente */}
        <g>
          <line x1="54" y1="54" x2="54" y2="35" stroke={ACC} strokeWidth="2.6" strokeLinecap="round">
            <animateTransform attributeName="transform" type="rotate" from="0 54 54" to="360 54 54" dur="1.5s" repeatCount="indefinite" />
          </line>
          <circle cx="54" cy="35" r="2.6" fill={ACC}>
            <animateTransform attributeName="transform" type="rotate" from="0 54 54" to="360 54 54" dur="1.5s" repeatCount="indefinite" />
          </circle>
        </g>

        {/* puntini "trovati" che lampeggiano */}
        <circle cx="44" cy="48" r="2" fill={ACC}>
          <animate attributeName="opacity" values="0;1;0" dur="1.5s" begin="0.2s" repeatCount="indefinite" />
        </circle>
        <circle cx="62" cy="60" r="2" fill={ACC}>
          <animate attributeName="opacity" values="0;1;0" dur="1.5s" begin="0.9s" repeatCount="indefinite" />
        </circle>

        {/* manico della lente */}
        <line x1="71" y1="71" x2="92" y2="92" stroke="#0f172a" strokeWidth="6" strokeLinecap="round" />
      </svg>
      <div style={{ fontSize: 13, fontWeight: 700, color: '#334155' }}>Indagine in corso…</div>
    </div>
  );
}
